// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.banks[data-v-f5b87858] {

    padding-top: 2.5rem;

    text-align: center
}
@media (min-width: 640px) {
.banks[data-v-f5b87858] {

        padding-bottom: 5rem
}
}
@media (min-width: 996px) {
.banks[data-v-f5b87858] {

        padding-bottom: 7.5rem
}
}
.banks__icon[data-v-f5b87858] {

    margin-bottom: 2rem;

    flex-shrink: 0;

    display: inline-block;

    background-size: contain;

    background-repeat: no-repeat;

    width: 3.5rem;

    height: 3.5rem;

    background-image: url("/img/web/icons/agreement.svg")
}
.banks__title[data-v-f5b87858] {

    margin-left: auto;

    margin-right: auto;

    text-transform: uppercase;

    --tw-text-opacity: 1;

    color: rgb(31 47 75 / var(--tw-text-opacity));

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700;

    width: 100%;

    padding-right: 1rem;

    padding-left: 1rem;

    margin: auto
}
@media (min-width: 640px) {
.banks__title[data-v-f5b87858] {

        padding-right: 1.5rem;

        padding-left: 1.5rem
}
}
@media (min-width: 1320px) {
.banks__title[data-v-f5b87858] {

        max-width: 1320px
}
}
@media (min-width: 640px) {
.banks__title[data-v-f5b87858] {

        --tw-text-opacity: 1;

        color: rgb(17 24 39 / var(--tw-text-opacity))
}
}
@media (min-width: 996px) {
.banks__title[data-v-f5b87858] {

        max-width: 42rem;

        font-family: Mont;

        line-height: 1;

        font-size: 2.5rem;

        font-weight: 700
}
}
.banks__slider[data-v-f5b87858] {

    position: relative;

    margin-top: 3.5rem;

    width: 100%;

    overflow: hidden
}
.banks__slider-track[data-v-f5b87858] {

    display: grid;

    grid-template-columns: repeat(4, minmax(0, 1fr));

    gap: 2rem;

    padding-left: 1.5rem;

    padding-right: 1.5rem
}
.banks__img[data-v-f5b87858] {

    max-height: 5.5rem;

    width: 100%;

    max-width: 8.5rem
}
.banks__img-container[data-v-f5b87858] {

    display: flex;

    flex-shrink: 0;

    flex-direction: row;

    align-items: center;

    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/BanksCarousel.vue"],"names":[],"mappings":";AAyCA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,cAAA;;IAAA,qBAAA;;IAAA,wBAAA;;IAAA,4BAAA;;IAAA,aAAA;;IAAA,cAAA;;IAAA;AAAA;AAIA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,yBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,gBAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,oBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,gBAAA;;QAAA,iBAAA;;QAAA,cAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,gDAAA;;IAAA,SAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,cAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"banks\">\n    <Icon class=\"banks__icon\" name=\"agreement\" color=\"none\" :size=\"60\" />\n    <h2 class=\"banks__title\">No somos un banco, pero trabajamos con todos</h2>\n    <div class=\"banks__slider\">\n      <div class=\"banks__slider-track\">\n        <div\n          class=\"banks__img-container\"\n          v-for=\"(bank, index) in banks[0]\"\n          :key=\"index\"\n        >\n          <img\n            class=\"banks__img\"\n            :alt=\"'Logo ' + bank.name\"\n            :src=\"bank.logo_url\"\n          />\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nexport default {\n  components: {\n    Icon,\n  },\n  setup(props, { root }) {\n    console.log(root.$page.props.banks);\n    \n    return {\n      banks: root.$page.props.banks,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.banks {\n  @apply text-center pt-sm sm:pb-xxl lg:pb-xxxl;\n\n  &__icon {\n    @apply icon icon-lg icon-agreement mb-xs;\n  }\n\n  &__title {\n    @apply container uppercase mx-auto text-brand-secondary-medium sm:text-neutral-ultradark style-subtitle-bold lg:style-title-bold lg:max-w-2xl;\n  }\n\n  &__slider {\n    @apply relative w-full overflow-hidden mt-lg;\n  }\n\n  &__slider-track {\n    @apply grid grid-cols-4 gap-xs px-xxs;\n  }\n\n  &__img {\n    @apply w-full max-w-[8.5rem] max-h-[5.5rem];\n  }\n\n  &__img-container {\n    @apply flex items-center flex-row justify-center shrink-0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
